import localStorage from 'utils/localStorage'

export const isTestEnv = () => localStorage.getItem('MC_ENV') === 'test'
